
import Vue from "vue"
import { mapGetters } from "vuex"
import { getBeforeAfter } from "@/utils/before-after"

export default Vue.extend({
  data: () => ({
    title: "",
  }),

  head () {
    return { title: this.getTitle(this.$t("pages.news.title")) }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),

    beforeAfter (): Partial<Record<string, number>> {
      const afterYear = Number.parseInt(String(this.$route.query.year))
      if (Number.isInteger(afterYear))
        return getBeforeAfter(undefined, afterYear)
      return {}
    },

    params (): Record<string, any> {
      return {
        "filter[type]": this.$route.query.type || "news",
        ...this.beforeAfter,
      }
    },
  },

  created () {
    this.title = `pages.news.${this.$route.query.type || "news"}`
  },
})
